import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { CustomCheckbox } from 'components/CustomCheckbox/CustomCheckbox';
import { InfoTooltip } from 'components/InfoTooltip/InfoTooltip';

import './LabelCheckbox.sass';

export const LabelCheckbox = ({
  label,
  id,
  value,
  onChange,
  disabled,
  icon,
  isEdited,
  name,
  tooltipText,
  error,
  testId,
}) => {
  const getClassnameForError = useMemo(() => {
    if (error) return 'error';
    return '';
  }, [error]);

  return (
    <div className="label-checkbox">
      <CustomCheckbox
        testId={testId}
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        name={name}
        isEdited={isEdited}
        tooltipText={tooltipText}
        error={error}
      />
      {icon && <img src={icon} alt="label-checkbox-icon" />}
      {label && (
        <label id={id} className={getClassnameForError} htmlFor={id}>
          {label}
        </label>
      )}
      {tooltipText && <InfoTooltip title={tooltipText} />}
    </div>
  );
};

LabelCheckbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  isEdited: PropTypes.bool,
  name: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  error: PropTypes.bool,
  testId: PropTypes.string,
};

LabelCheckbox.defaultProps = {
  label: '',
  icon: '',
  tooltipText: '',
  error: false,
  disabled: false,
  isEdited: false,
  testId: '',
};
